module.exports = __webpack_public_path__ + "img/7.2835396c.jpeg";